var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { Component } from 'react';
import { createSelector } from 'reselect';

import { connect } from 'react-redux';

import { Translate } from "../I18N";
import { TableRows } from "./TableRows";






class TableViewerComponent extends Component {


  render() {
    const columns = this.props.columns.filter((c) => !c.hidden);
    return /*#__PURE__*/(
      _jsx("div", { className: "tableview-wrapper" }, void 0, /*#__PURE__*/
      _jsx("table", {}, void 0, /*#__PURE__*/
      _jsx("thead", {}, void 0, /*#__PURE__*/
      _jsx("tr", {}, void 0,
      columns.map((column, index) => /*#__PURE__*/
      _jsx("th", { className: !index ? 'sticky-col' : '' }, column.name, /*#__PURE__*/
      _jsx("div", { className: "table-view-cell" }, void 0, /*#__PURE__*/
      _jsx(Translate, { context: column.translationContext }, void 0, column.label)
      )
      )
      )
      )
      ), /*#__PURE__*/
      _jsx("tbody", {}, void 0, /*#__PURE__*/
      _jsx(TableRows, {
        columns: columns,
        clickOnDocument: this.props.clickOnDocument,
        storeKey: this.props.storeKey }
      )
      )
      )
      ));

  }
}_defineProperty(TableViewerComponent, "wrapLoader", true);

const getTableViewColumnsSelector = (state) => state.ui.get('tableViewColumns');
const selectTableViewColumns = createSelector(getTableViewColumnsSelector, (columns) =>
columns === null || columns === void 0 ? void 0 : columns.toJS()
);

const mapStateToProps = (state, props) => ({
  columns: selectTableViewColumns(state[props.storeKey])
});

export { selectTableViewColumns };


export const TableViewer = connect(mapStateToProps)(TableViewerComponent);